import { render, staticRenderFns } from "./CoursewareKeyPointBlock.vue?vue&type=template&id=4fe56484&scoped=true&"
import script from "./CoursewareKeyPointBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareKeyPointBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareKeyPointBlock.vue?vue&type=style&index=0&id=4fe56484&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe56484",
  null
  
)

export default component.exports